<button
  type="button"
  class="btn btn-border-radius btn-secondary visual-link-button"
  [attr.aria-disabled]="monDisabled || loading || page?.type !== 'html' ? 'true' : null"
  [disabled]="monDisabled"
  [ngbTooltip]="'Inspect page with browser extension' | translate"
  [triggers]="'focus:blur mouseenter:mouseleave'"
  [placement]="tooltipPlacement || 'top'"
  [container]="'body'"
  [tooltipClass]="'text-ellipsis'"
  (click)="onClick()"
  [monEventTrigger]="'actionTrigger'"
  [monEventParams]="{action: 'redirect-to-page-btn', params: {module: moduleName}}"
  [title]="page?.type === 'html' ? '' : ('Cannot redirect to Document' | translate)"
  [attr.aria-label]="page?.type === 'html' ? ('Inspect page with browser extension' | translate) : ('Cannot redirect to Document' | translate)"
  tabindex="0"
>
  <mon-icon [monIconDirect]="'faSearch'"
          title="{{'Browser Extension' | translate}}"
          aria-hidden="true">
  </mon-icon>
</button>
